import { ComponentProps, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type TileProps = ComponentProps<'div'>;

export const Tile: FC<TileProps> = ({ className, ...rest }) => <div className={twMerge('rounded-md shadow bg-white-100 py-[9px] px-[17px]', className)} {...rest} />;
